<template>
  <div>
    <div v-if="isShow">
      <el-dialog
        :title="title"
        :visible.sync="showDialog"
        class="app-content-model"
        :before-close="onCancel"
      >
        <div style="height: 100%">
          <img v-if="type == 'img'" :src="src" alt="" />

          <video
            v-if="type == 'video' && src.indexOf('.m3u8') == -1"
            controls="controls"
            :src="src"
          ></video>
          <xb-player
            v-if="type == 'video' && src.indexOf('.m3u8') != -1"
            :src="src"
            height="auto"
            :fullScreen="true"
            width="500px"
            :autoplay="false"
          ></xb-player>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import XbPlayer from "@/components/player/XbPlayer.vue";
export default {
  name: "app-content-modal",
  data() {
    return {
      title: "提示",
      src: "",
      type: "img",
      content: null,
      cancelText: "取消",
      confirmText: "确认",
      cancel: function () {},
      confirm: function () {},
      isSync: false,
      isShow: false,
      showDialog: true,
    };
  },
  components: {
    XbPlayer,
  },
  methods: {
    onCancel() {
      if (!this.isSync) this.isShow = false;
      this.cancel();
    },
    onConfirm() {
      if (!this.isSync) this.isShow = false;
      this.confirm();
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog__body {
  padding: 10px 20px 20px !important;
}
::v-deep .app-content-model .el-dialog {
  width: auto !important;
  max-height: 90vh !important;
}

::v-deep .app-content-model .el-dialog .el-dialog__body {
  height: calc(90vh - 55px);
}

::v-deep .app-content-model .el-dialog video {
  height: 100%;
}
::v-deep .app-content-model .el-dialog img {
  height: 100%;
}
</style>
